import http from 'hub-http/clients/apiClient';
export function fetchChannelInstances(channelId, limit) {
  return http.get(`conversations-channels/v1/channel-instances/channelId/${channelId}?deletedFilter=NON_DELETED_ONLY&limit=${limit}`);
}